export default "__VITE_ASSET__CXIT3HSB__"